import React from "react";
import { ScenarioEntity } from "../../scenario/domain/scenario.entity";
import { ConditionChips } from "./ConditionChips";

interface ScenarioDetailsProps {
  scenarioId: string;
  scenarios: ScenarioEntity[];
}

export const ScenarioDetails: React.FC<ScenarioDetailsProps> = ({ scenarioId, scenarios }) => {
  const scenario = scenarios.find(it => it.id === scenarioId);

  if (!scenario) return null;

  return <ConditionChips criteria={scenario.criteria} />;
};
